import { PREVIEW_CANVAS_ADDITIONAL_FREE_SPACE, PREVIEW_SUMMARY_EXTRA_HEIGHT_INDENT, PREVIEW_SUMMARY_WIDTH_INDENT } from 'constant'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import * as Selectors from '~/selectors'
import { DEFAULT_VIDEO_WIDTH, DEFAULT_VIDEO_HEIGHT } from '~/Util'

/**
 * @param {{ width: number, height: number }} viewport
 * @returns {{
 *  rect: { width: number, x: number, y: number, height: number },
 *  scale: { x: number, y: number },
 * }}
 */
export default function useCanvasParams({ width, height }) {
  const video = useSelector(Selectors.getReferenceVideoAsset)

  return useMemo(() => {
    let scale = { x: 1, y: 1 }
    let rect = {
      width,
      height,
      x: 0,
      y: 0,
    }

    if (width > 0 && height > 0) {
      const videoWidth = video?.id ? video.width : DEFAULT_VIDEO_WIDTH
      const videoHeight = video?.id ? video.height : DEFAULT_VIDEO_HEIGHT
      const videoRatio = videoWidth / videoHeight
      rect = {
        width: height * videoRatio,
        height: width / videoRatio,
      }

      // Get rect with videoRatio based on min width
      rect.width = Math.round(Math.min(rect.width, width)) - PREVIEW_SUMMARY_WIDTH_INDENT
      rect.height = Math.round(rect.width / videoRatio)

      // Adjust rect if its height has appeared to be more than viewport height
      if (height <= (rect.height + PREVIEW_CANVAS_ADDITIONAL_FREE_SPACE)) {
        rect.height -= PREVIEW_SUMMARY_EXTRA_HEIGHT_INDENT
        rect.width = Math.round(rect.height * videoRatio)
      }

      if (document.fullscreenElement) {
        rect.height = height
      }

      rect.x = 0 // Math.round((width - rect.width) / 2)
      rect.y = 0 // Math.round((height - rect.height) / 2)

      rect.offsetX = Math.round((width - rect.width) / 2)
      rect.offsetY = Math.round((height - rect.height) / 2)

      scale = {
        x: rect.width / videoWidth,
        y: rect.height / videoHeight,
      }
    }

    return { rect, scale, video }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ video, height, width ])
}
